// @flow
/** @jsx h */
import { h } from 'preact';
import { useEffect, useState } from 'preact/hooks';
import ShareNtbApp from '../ShareNtbApp';
import OnSuccessSharedNtbLinkMsg from '../OnSuccessSharedNtbLinkMsg';
import {
  useSalesContext,
  useSalesDispatchContext,
} from '../../../storeProviders/salesAppStore';
import { sendNtbApplicationLink } from '../../../api/controllers/salesController';
import { useRequest } from '../../../api/services/useRequest';
import useSalesAppError from '../hooks/useSalesAppError';
import { useSalesAppTracker } from '../tracker';

const ShareNtbAppContainer = () => {
  const pageKey = 'sa_click_ntb_application_share';
  const [btnTxtForShareNtbApp, changeBtnTextForShareNtbApp] = useState(
    'Share Credit Application',
  );
  const [btnTxtForSuccessMsg, changeBtnTxtForSuccessMsg] = useState(
    'Send on WhatsApp',
  );
  const [showShareNtbAppScreen, setShareNtbAppScreen] = useState(true);
  const [showOnSuccessScreen, setOnSuccessScreen] = useState(false);
  const salesState = useSalesContext();
  const salesDispatch = useSalesDispatchContext();
  const sendNtbApplicationRequest = useRequest();
  const { bottomSheetConfig, mobile, selectedLenderDetails, whatsAppLink } =
    salesState || {};
  const { lenderId } = selectedLenderDetails || {};
  const [userName, setUserName] = useState('');
  const salesAppTracker = useSalesAppTracker(pageKey);

  const { setSalesAppErrorModal } = useSalesAppError();
  const handleBtnClickForNtbApp = async (email, name) => {
    salesAppTracker.trackClick('sa_click_ntb_application_share', undefined);
    await sendNtbApplicationLink(sendNtbApplicationRequest.makeRequest, {
      mobile,
      lenderId,
      email,
      userName: name,
    });

    setOnSuccessScreen(true);
    setShareNtbAppScreen(false);
    setUserName(name ? name : 'user');
  };

  useEffect(() => {
    if (sendNtbApplicationRequest.value) {
      salesAppTracker.trackPageView('sa_pv_ntb_application_shared');
      salesDispatch({
        type: 'STORE_STATE',
        payload: {
          ntbLink: sendNtbApplicationRequest.value.ntbLink,
          whatsAppLink: sendNtbApplicationRequest.value.whatsAppLink,
        },
      });
    }
  }, [sendNtbApplicationRequest.value]);

  useEffect(() => {
    if (sendNtbApplicationRequest.error) {
      setSalesAppErrorModal({
        ...sendNtbApplicationRequest.error,
        isRetryAllowed: true,
      });
    }
  }, [sendNtbApplicationRequest.error]);

  const handleBtnClickForSuccessScreen = () => {
    setOnSuccessScreen(false);
    setShareNtbAppScreen(false);
    salesDispatch({
      type: 'STORE_STATE',
      payload: {
        bottomSheetConfig: {
          showOverlay: false,
        },
      },
    });
    window.open(whatsAppLink, '__blank');
  };

  return (
    <div>
      {bottomSheetConfig.moduleName === 'SHARE_NTB_APP' &&
      showShareNtbAppScreen ? (
        <ShareNtbApp
          btnTxt={btnTxtForShareNtbApp}
          handleBtnClickForNtbApp={handleBtnClickForNtbApp}
          loading={sendNtbApplicationRequest.loading}
        />
      ) : (
        showOnSuccessScreen && (
          <OnSuccessSharedNtbLinkMsg
            btnTxt={btnTxtForSuccessMsg}
            handleBtnClickForSuccessScreen={() =>
              handleBtnClickForSuccessScreen()
            }
            userName={userName}
          />
        )
      )}
    </div>
  );
};

export default ShareNtbAppContainer;



// WEBPACK FOOTER //
// ./components/salesApp/common/ShareNtbAppContainer.js